import * as React from 'react';
import DOMPurify from 'dompurify';
if (DOMPurify && typeof window !== 'undefined') {
    DOMPurify.addHook('uponSanitizeAttribute', (node, attr) => {
        if (node.nodeName === 'A' && attr.attrName === 'target' && attr.attrValue === '_blank') {
            node.__target = attr.attrValue;
        }
    });
    DOMPurify.addHook('afterSanitizeAttributes', (node) => {
        if (node.__target) {
            node.target = node.__target;
            node.setAttribute('rel', 'noopener noreferrer');
        }
    });
}
export const sanitizeHTML = (htmlString) => {
    if ('sanitize' in DOMPurify) {
        return DOMPurify.sanitize(htmlString);
    }
    return '';
};
export const DangerousElement = ({ html, as = 'div', sanitize = true, }) => {
    if (typeof window === 'undefined') {
        return React.createElement(as, {}, html);
    }
    return React.createElement(as, {
        dangerouslySetInnerHTML: { __html: sanitize ? sanitizeHTML(html) : html },
    });
};
